import React, {useState, useEffect} from 'react';

// styles
import {
  BannerWrapper,
  BannerContent,
  CloseButton,
  WarningBannerText,
} from './WarningBanner-styles';

// assets
import {ReactComponent as CloseIcon} from '../../../assets/icons/ic_close.svg';
// helpers
import {useTranslation} from 'react-i18next';

// services
import {
  getSessionStorage,
  setSessionStorage,
  sessionStorageDictionary,
} from '../../../sessionStorage';

interface WarningBannerProps {
  shouldShow: boolean;
}

const WarningBanner = ({shouldShow}: WarningBannerProps) => {
  const {t} = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (shouldShow) {
      // Check if banner was dismissed in this session
      const isDismissed = getSessionStorage(
        sessionStorageDictionary.WARNING_BANNER_DISMISSED,
      );
      setIsVisible(isDismissed === 'false');
    } else {
      setIsVisible(false);
    }
  }, [shouldShow]);

  const handleClose = () => {
    setIsVisible(false);
    // Mark as dismissed for this session
    setSessionStorage(
      sessionStorageDictionary.WARNING_BANNER_DISMISSED,
      'true',
    );
  };

  if (!isVisible) {
    return null;
  }

  return (
    <BannerWrapper>
      <BannerContent>
        <WarningBannerText>{t('warning_banner_message')}</WarningBannerText>
      </BannerContent>
      <CloseButton onClick={handleClose} aria-label="Close warning banner">
        <CloseIcon width={32} height={32} />
      </CloseButton>
    </BannerWrapper>
  );
};

export default WarningBanner;
